import CommandWindow from "./outputWindow";

export default CommandWindow;